import React from 'react';
import { useDroppable } from '@dnd-kit/core';

interface CalendarDayProps {
  dateStr: string;
  isCurrentMonth: boolean;
  dayNumber: string;
  monthAbbr?: string;
  children: React.ReactNode;
  isExpanded: boolean;
  isPrimaryMonth: boolean;
}

export function CalendarDay({ dateStr, isCurrentMonth, dayNumber, monthAbbr, children, isExpanded, isPrimaryMonth }: CalendarDayProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: `day-${dateStr}`,
    data: { dateStr },
  });

  return (
    <div
      ref={setNodeRef}
      className={`border-r border-b last:border-r-0 ${isExpanded ? 'min-h-28 p-2' : 'min-h-20 p-1.5'} ${
        isCurrentMonth ? 'bg-card' : 'bg-muted/30'
      } ${isOver ? 'ring-2 ring-primary ring-inset' : ''}`}
    >
      <div className={`font-medium text-right ${isExpanded ? 'text-sm mb-2' : 'text-xs mb-1'} ${
        isCurrentMonth ? 'text-foreground' : 'text-muted-foreground/50'
      }`}>
        {dayNumber}
        {monthAbbr && (
          <span className="font-semibold text-muted-foreground">
            {' '}{monthAbbr}
          </span>
        )}
      </div>
      {children}
    </div>
  );
}
